/**
 * 인구통계 선택지 — 서버(functions/src/demographics.js)의 목록과 **글자까지 같아야** 한다.
 * 다르면 서버 allowlist 에서 조용히 버려진다(에러도 안 난다). 테스트로 못 막으므로
 * 여기 값을 고칠 일이 생기면 서버를 먼저 고치고 그대로 옮긴다.
 */
export const AGE_BANDS = ["10대", "20대", "30대", "40대", "50대", "60대 이상"];

export const JOBS = [
  "학생", "사무·관리", "기술·개발", "디자인·창작", "교육·연구",
  "의료·복지", "생산·기능", "서비스·판매", "자영업", "무직·기타",
];

export const GENDERS = ["남성", "여성", "밝히지 않음"];

/** 하나도 안 고르면 보낼 것이 없다 — 빈 값을 저장해 둘 이유가 없다. */
export const hasAny = (d) => Boolean(d && (d.ageBand || d.job || d.gender));
